import { useApplicationModals } from "app/common/hooks";
import { ModalMolecule } from "app/components/molecules/modal";
import { usePaginatedCollector } from "app/integration/common/hooks";
import React, { useState, useEffect } from "react";
import Table, { TableCell } from "app/components/atoms/table";
import Typography from "app/components/atoms/typography";
import { CheckCircleIcon, CheckIcon, PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { Badge } from "app/components/atoms/badge";
import { BadgeButton, IconButton, ServerSidePaginationButtons } from "app/components/atoms/button";
import { Input, SearchInput } from "app/components/atoms/input";
import { FormHeader } from "app/components/atoms/layout";

function ChooseCustomer({ onSuccess = () => { } }) {
  const { showStates, getPayloads, closeModal } = useApplicationModals();
  const payload = getPayloads("customer.choose");

  const handleClose = () => {
    closeModal("customer.choose");
  };
  const handleSuccess = (data) => {
    closeModal("customer.choose");
    // console.log("customer", data)
    onSuccess(data);
  };

  const [openRow, setOpenRow] = useState(null);

  const toggleRow = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  const [params, setParams] = useState({
    search: "",
    createdAt: null,
    customer_id: null,
    status: null,
    is_valid_order: null,
    page: 1,
    limit: 20,
  });

  const [searchValue, setSearchValue] = useState('');

  const [
    customers,
    setCustomers,
    customersLoader,
    collectCustomers,
    customerPaginationProps,
  ] = usePaginatedCollector({ modelName: "customer", params: params });

  const filteredCustomers = searchValue
    ? customers?.filter((customer) => {
      const customerName = `${customer.firstName || ''} ${customer.middleName || ''} ${customer.lastName || ''}`.toLowerCase();
      const customerNickName = customer.nickName?.toLowerCase() || '';
      const customerPhone = customer.phone?.toLowerCase() || '';

      return (
        customerName.includes(searchValue.toLowerCase()) ||
        customerNickName.includes(searchValue.toLowerCase()) ||
        customerPhone.includes(searchValue.toLowerCase())
      );
    })
    : customers;

  return (
    <ModalMolecule
      show={showStates["customer.choose"]}
      title="Customer"
      onClose={handleClose}
      size="lg"
    >
      <Table.Container>
        <Table.UtilitiesWrapper>
          <Table.SearchBarWrapper>
            <FormHeader appearance="none">
              <SearchInput testId="modal-choose-customer-search-input"
                placeholder="Cari Customer"
                type="text"
                value={params.search}
                onChange={(e) => setParams({ ...params, search: e.target.value })}
              />
            </FormHeader>
          </Table.SearchBarWrapper>
        </Table.UtilitiesWrapper>
        <Table.Wrapper asIndex={true}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading>No.</Table.Heading>
              <Table.Heading>Customer</Table.Heading>
              <Table.Heading>Email</Table.Heading>
              <Table.Heading>Telepon</Table.Heading>
              <Table.Heading></Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {filteredCustomers?.map((customer, key) => (
              <React.Fragment key={key}>
                <Table.BodyRow>
                  <Table.Cell>
                    {key + 1}
                  </Table.Cell>
                  <Table.Cell>
                    <p>
                      {customer?.firstName} {customer?.middleName} {customer?.lastName}
                      {customer?.nickName !== null && customer?.nickName !== "" && " (" + customer?.nickName + ")"}
                    </p>
                  </Table.Cell>
                  <Table.Cell>
                    <p className="text-left">{customer?.email}</p>
                  </Table.Cell>
                  <Table.Cell>
                    <p className="text-left">{customer?.phone}</p>
                  </Table.Cell>
                  <Table.Cell>
                    <div className="flex space-x-2">
                      <div className="flex">
                        <IconButton testId="modal-choose-customer-check-circle-button"
                          color="green"
                          icon={CheckCircleIcon}
                          onClick={(e) => {
                            handleSuccess(customer);
                          }}
                        />
                      </div>
                    </div>
                  </Table.Cell>
                </Table.BodyRow>
              </React.Fragment>
            ))}
          </Table.Body>
        </Table.Wrapper>
        <Table.PaginationWrapper>
          <ServerSidePaginationButtons
            paginationProps={customerPaginationProps}
            params={params}
            setParams={setParams}
          />
        </Table.PaginationWrapper>
      </Table.Container>
    </ModalMolecule>
  );
}

export default ChooseCustomer;
